import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { useCompaniesApi } from '@/services/api';
import { useAuth } from '@/hooks/useAuth';
import { landingSectionFor } from '@/lib/permissions';
import { t } from '@/i18n';

export function RootRedirect() {
  const navigate = useNavigate();
  const { getCompanies } = useCompaniesApi();
  const { isSuperAdmin, permissions, isAuthReady } = useAuth();
  const [noAccess, setNoAccess] = useState(false);

  useEffect(() => {
    // Wait for isAuthReady: picking a landing section from a still-loading
    // (null) permissions snapshot would send a module-restricted user to
    // /invoices, only to be corrected (or rejected) once the real
    // permissions arrive — the exact race this hook exists to avoid.
    if (!isAuthReady) return;

    let cancelled = false;
    async function redirect() {
      try {
        const companies = await getCompanies();
        if (cancelled) return;
        if (companies.length > 0) {
          const nip = companies[0].nip;
          navigate(`/${nip}/${landingSectionFor(isSuperAdmin, permissions, nip)}`, { replace: true });
        } else {
          setNoAccess(true);
        }
      } catch {
        if (!cancelled) setNoAccess(true);
      }
    }
    redirect();
    return () => {
      cancelled = true;
    };
  }, [isAuthReady, isSuperAdmin, permissions, getCompanies, navigate]);

  if (noAccess) {
    return (
      <div className="flex h-full items-center justify-center">
        <p className="text-muted-foreground text-sm">{t('errors.accessDenied')}</p>
      </div>
    );
  }

  return (
    <div className="flex h-full items-center justify-center">
      <Loader2 className="text-muted-foreground size-8 animate-spin" />
    </div>
  );
}
